import { HttpService } from '@Engage.Data.Services';
import { Locations } from '@Engage.Core';
/**
 * Mirrors ConneXt v2 ActivationRepository + LinkAccountService API calls.
 */
export class ActivationRepository {
    /** POST user/{searchOption} — links a print subscription to the digital account */
    static linkAccount(searchOption, payload) {
        return HttpService.post('user/' + searchOption, payload, this.options);
    }
    /** GET user/DigitalAccess — checks if user has digital access after linking */
    static checkDigitalAccess(masterId, mode = 0) {
        return HttpService.get(`user/DigitalAccess?masterId=${masterId}&mode=${mode}`, null, this.options);
    }
    /** GET dictionary/productCode — gets the product code for upgrade links */
    static getProductCode() {
        return HttpService.get('dictionary/productCode');
    }
}
ActivationRepository.options = { location: Locations.Activation };
